import { DateTime } from 'luxon'

export const UK_TIME_ZONE = 'Europe/London'

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

/** Today's calendar date in Europe/London (YYYY-MM-DD). */
export function ukTodayIso(
  reference: DateTime = DateTime.now().setZone(UK_TIME_ZONE)
): string {
  const zoned = reference.setZone(UK_TIME_ZONE).startOf('day')
  return zoned.toISODate() ?? ''
}

function isIsoDate(value: string): boolean {
  return ISO_DATE_PATTERN.test(value)
}

/** Parse a donor-facing calendar date as midnight in Europe/London. */
export function parseUkIsoDate(isoDate: string): DateTime {
  return DateTime.fromISO(isoDate, { zone: UK_TIME_ZONE }).startOf('day')
}

/**
 * Persist a date-only gift as noon Europe/London so UK tax-year logic stays
 * on the intended calendar day around DST.
 */
export function ukDateToDonationIso(isoDate: string): string {
  const dt = parseUkIsoDate(isoDate).set({
    hour: 12,
    minute: 0,
    second: 0,
    millisecond: 0,
  })
  return dt.toUTC().toISO() ?? `${isoDate}T12:00:00.000Z`
}

/** Calendar day in Europe/London for a stored donation timestamp. */
export function donationIsoToUkDate(iso: string): string {
  if (isIsoDate(iso)) return iso
  const dt = DateTime.fromISO(iso, { zone: UK_TIME_ZONE })
  return dt.toISODate() ?? iso.slice(0, 10)
}
